export const config ={
  "pdfToOfficeVersion": "2023.11.27 version",
  "officeToPdfVersion": "2023.10.15 version",
  "pdfToOfficeLinuxVersion": "2023.08.02 version",
  "pheePlatformUrl": "https://pheeplatform.foxit.com",
  "pheecwsUrls": {
    "prod": "https://pheecws.foxit.com",
    "azk8s": "https://pheecws-azk8s.foxitcloud.com/",
  },
  "downloadKey": "POdfD8JD46DU",
  "downloadCommonToken": "phantomOnline",
}